export default __webpack_public_path__ + "static/media/olva-ambalaj-web.9c001c32.jpg";